<div
    class="py-3"
    [formGroup]="form()">
    <div class="mb-4">
        <text-input
            [formGroup]="form()"
            id="name"
            required="true"
            focus="true"
            label="Category Name" />

        <name-validation-errors
            [formGroup]="form()"
            id="name"
            label="Category Name" />
    </div>


</div>
